var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuideBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 173,
    viewBox: "0 0 174 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1V168.5H173.5",
    stroke: "#A24E25",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.063 165.337C46.979 165.26 46.979 165.136 47.063 165.058C47.1436 164.981 47.2811 164.981 47.3617 165.058L50.937 168.36C51.021 168.438 51.021 168.562 50.937 168.64L47.3617 171.942C47.2811 172.019 47.1436 172.019 47.063 171.942C46.979 171.864 46.979 171.74 47.063 171.663L50.487 168.5L47.063 165.338V165.337Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66281 124.063C7.74034 123.979 7.86432 123.979 7.94185 124.063C8.01938 124.144 8.01938 124.281 7.94185 124.362L4.63952 127.937C4.56199 128.021 4.43801 128.021 4.36048 127.937L1.05815 124.362C0.980618 124.281 0.980618 124.144 1.05815 124.063C1.13567 123.979 1.25966 123.979 1.33719 124.063L4.4998 127.487L7.66281 124.063Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66281 45.063C7.74034 44.979 7.86432 44.979 7.94185 45.063C8.01938 45.1436 8.01938 45.2811 7.94185 45.3617L4.63952 48.937C4.56199 49.021 4.43801 49.021 4.36048 48.937L1.05815 45.3617C0.980618 45.2811 0.980618 45.1436 1.05815 45.063C1.13567 44.979 1.25966 44.979 1.33719 45.063L4.4998 48.487L7.66281 45.063Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.063 165.337C124.979 165.26 124.979 165.136 125.063 165.058C125.144 164.981 125.281 164.981 125.362 165.058L128.937 168.36C129.021 168.438 129.021 168.562 128.937 168.64L125.362 171.942C125.281 172.019 125.144 172.019 125.063 171.942C124.979 171.864 124.979 171.74 125.063 171.663L128.487 168.5L125.063 165.338V165.337Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideBg);
export default __webpack_public_path__ + "static/media/guide-bg.0401c560d36e1ff9fb33030ad1f077a7.svg";
export { ForwardRef as ReactComponent };